import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconSwatches = props => {
  const $ = _c(7);
  const color = props.color || "#585858";
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M23.858496,19.748592 L12.686976,19.748592 C11.398176,19.748592 10.352736,18.703152 10.352736,17.414352 L10.352736,3.414672 C10.352736,2.125872 11.398176,1.080432 12.686976,1.080432 L23.858496,1.080432 C25.148736,1.080432 26.192736,2.125872 26.192736,3.414672 L26.192736,17.414352 C26.192736,18.703152 25.148736,19.748592 23.858496,19.748592 Z" />;
    t1 = <path d="M10.35288,3.613248 L2.61,6.461568 C1.39896,6.905088 0.77976,8.247168 1.22328,9.458208 L6.05592,22.596768 C6.49944,23.806368 7.84152,24.427008 9.05256,23.983488 L18.11016,20.652768 L24.2028,24.170688 C25.32024,24.815808 26.74728,24.432768 27.3924,23.316768 L34.3908,11.193408 C35.03736,10.075968 34.65432,8.647488 33.53688,8.003808 L26.19288,3.763008" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g stroke={color} strokeWidth="1.5">{t0}{t1}</g></g>;
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <svg width={18} height={13} viewBox="0 0 36 26" {...props}>{t2}</svg>;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
IconSwatches.propTypes = {
  color: PropTypes.string
};
export default IconSwatches;